import { Outlet } from "react-router-dom";

/** Centred card for the login screen — template §2's second layout. */
export default function AuthLayout() {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="text-center mb-4">
          <i className="bi bi-graph-up-arrow auth-logo" />
          <h1 className="h5 mt-2 mb-0">VVR ERP</h1>
          <div className="text-muted small">Reports &amp; Dashboards</div>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
